// eslint-disable-next-line no-restricted-imports
import features from '@mail/features';
import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

features.get = (featureName) => {
    if (!isFeature(featureName)) {
        return undefined;
    }
    const value = getFeature(featureName);
    return { data: value, source: ['onlineconf' as any], name: featureName, state: true };
};
delete (features as any).list;
Object.defineProperty(features, 'list', {
    get() {
        throw new Error('incorrect get list');
    },
    set() {
        throw new Error('incorrect set list');
    },
});

export { features };
